import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export type CreditOrderData = object;

@Component({
  selector: 'admin-credit-order-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDividerModule,
  ],
  templateUrl: './credit-order-modal.component.html',
  styleUrls: ['./credit-order-modal.component.scss'],
})
export class CreditOrderModalComponent {
  constructor(
    public dialogRef: MatDialogRef<CreditOrderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreditOrderData,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
